module.exports = __webpack_public_path__ + "static/media/Technos_diagonales_05.dcaa47af.png";